var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form.userid != 1)?_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Delete"},on:{"click":function($event){return _vm.deleteUser(_vm.form.userid)}}},[_c('img',{attrs:{"src":'/images/delete.png'}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }